<!-- Content for internal users (AI-recommended features) -->
@if (isAiFeatureEnabled === true) {
  <ng-content select="[phase=ai]"></ng-content>
}

<!-- Content for external/non-internal users -->
@if (isAiFeatureEnabled === false) {
  <ng-content select="[phase=ga]"></ng-content>
}
